import {useEffect, useMemo} from 'react';
import {Link} from 'react-router-dom';
import {useQueryParam} from 'use-query-params';

import {connect} from 'react-redux';
import PageMonitors from './_page_monitoring/_page_monitors';

const CompanySettingsMonitors = props => {
  const {rivals = {}, loadOrFetchRivals} = props;
  const rivalsList = (Object.values(rivals || {})).slice().sort((a, b) => a.name.localeCompare(b.name));
  const [rivalId, setRivalId] = useQueryParam('rivalId');

  const onEdit = rival => {
    setRivalId(rival?.id);
  };

  const rivalFromUrl = useMemo(() => {
    return rivals[rivalId];
  }, [rivals, rivalId]);

  useEffect(() => {
    loadOrFetchRivals();
  }, [loadOrFetchRivals]);

  return (
    <div className="company-settings company-settings-monitors">
      <h3 className="u-m0">Monitors Settings</h3>
      <p className="help-block u-mb-m">Manage your <Link to="/monitors"><strong>Monitors</strong></Link> settings.</p>

      <div>
        <h4 className="u-pt-s"><strong>Settings</strong></h4>
        <p className="help-block">Customize your page monitoring preferences.</p>

        {rivalsList.map(rival => {
          return (
            <div className="monitor-settings" key={rival.id}>
              <div className="monitor-settings-item" data-tracking-id="monitor-settings-item">
                <span className="monitor-settings-item-rival">
                  <span className="nav-sidebar-link_image">
                    <img src={rival.iconUrl} srcSet={rival.iconUrl} loading="lazy" />
                  </span>
                  <span>{rival.name}</span>
                </span>
                <div className="monitor-settings-item-status">
                  <span className="monitor-settings-item-meta" data-tracking-id="monitor-settings-item-meta">
                    <a data-testid="edit" data-tracking-id="monitor-settings-item-meta-edit-button" onClick={() => onEdit(rival)}>Edit</a>
                  </span>
                </div>
              </div>
            </div>
          );
        })}

        {rivalFromUrl && <PageMonitors
          rivalId={rivalFromUrl.id}
          rival={rivalFromUrl}
          onClose={() => onEdit(null)} />}

      </div>

    </div>
  );
};

CompanySettingsMonitors.propTypes = {
  rivals: PropTypes.object,
  loadOrFetchRivals: PropTypes.func
};

CompanySettingsMonitors.defaultProps = {
  rivals: {},
  loadOrFetchRivals() {}
};

const mapStateToProps = ({rivals}) => ({rivals: rivals.items});

const mapDispatchToProps = dispatch => ({
  loadOrFetchRivals: () => dispatch.rivals.loadOrFetchRivals()
});

export default connect(mapStateToProps, mapDispatchToProps)(CompanySettingsMonitors);
